/* Equal visible left inset and baseline inset; g/p/y do not shift the title. */
(() => {
  const context = document.createElement('canvas').getContext('2d');
  if (!context) return;
  let pending = false;
  const selector = '.ak-carousel-editorial-title h2,.ak-astro-sculpture__heading h2';
  function fit() {
    pending = false;
    document.querySelectorAll(selector).forEach(title => {
      if (!title.getBoundingClientRect().width) return;
      const style = getComputedStyle(title);
      const size = parseFloat(style.fontSize);
      const line = parseFloat(style.lineHeight) || size;
      const gap = parseFloat(getComputedStyle(title.parentElement).paddingLeft);
      context.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
      context.fontKerning = style.fontKerning;
      const ink = context.measureText(title.textContent.trim());
      // Font metrics locate the CSS baseline. Never use the heading's own
      // actualBoundingBoxDescent: that would lift words containing descenders.
      const reference = context.measureText('H');
      const ascent = reference.fontBoundingBoxAscent || size * .9;
      const descent = reference.fontBoundingBoxDescent || size * .2;
      const belowBaseline = (line - ascent + descent) / 2;
      title.style.setProperty('--ak-display-title-left', `${gap + ink.actualBoundingBoxLeft}px`);
      title.style.setProperty('--ak-display-title-bottom', `${gap - belowBaseline}px`);
    });
  }
  function queue() { if (!pending) { pending = true; requestAnimationFrame(fit); } }
  const observer = new ResizeObserver(queue);
  function init() {
    document.querySelectorAll(selector).forEach(title => {
      observer.observe(title);
      observer.observe(title.parentElement);
    });
    queue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.fonts.ready.then(queue);
  window.addEventListener('resize',queue,{passive:true});
  document.addEventListener('shopify:section:load',init);
})();
